import { Line } from 'react-chartjs-2';
import { Block } from '@attom';

import CS from './HistoryLineChart.module.scss';
import { Dates } from '@utils';

export const HistoryLineChart = ({
	// box control
	boxClass = '',
	boxSpace = '',
	boxSize = '',
	//
	width = null,
	height = null,
	//
	history = [],
	priceProperty = 'SELLPRICE',
}) => {
	// const lastHistory = history.length > 7 ? history.slice(history.length - 7) : history;
	const lastHistory = history;
	const isPositive =
		lastHistory.length >= 1 && lastHistory[lastHistory.length - 1][priceProperty] >= lastHistory[0][priceProperty];

	const data = {
		labels: lastHistory.map((item) =>
			item?.HISTORYDATE ? Dates.geoDaysObj[new Date(item.HISTORYDATE).getDay()] : '-',
		),
		datasets: [
			{
				label: '',
				data: lastHistory.map((item) => item[priceProperty]),
				fill: true,
				borderColor: isPositive ? '#00C851' : '#FF3547',
				backgroundColor: isPositive ? '#00C85144' : '#FF354744',
				tension: 0.1,
			},
		],
	};

	const options = {
		responsive: true,
		plugins: {
			legend: {
				display: false,
			},
			tooltip: {
				enabled: false,
			},
		},
		elements: {
			line: {
				tension: 0.1,
			},
		},
		interaction: {
			intersect: false,
		},
		scales: {
			y: {
				beginAtZero: false,
				ticks: {
					display: false,
				},
				grid: {
					display: false,
				},
			},
			x: {
				ticks: {
					display: false,
				},
				grid: {
					display: false,
				},
			},
		},
	};

	return (
		<Block boxClass={`${boxClass} ${CS.container}`} boxSize={boxSize} boxSpace={boxSpace}>
			<Line data={data} options={options} width={width} height={height} className={CS.container} />
		</Block>
	);
};
